<template>
    <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.55 18.2402C8.82846 18.401 9.17154 18.401 9.45 18.2402L16.3442 14.2598C16.6227 14.099 16.7942 13.8019 16.7942 13.4804V5.51962C16.7942 5.19808 16.6227 4.90096 16.3442 4.74019L9.45 0.759809C9.17154 0.599039 8.82846 0.599041 8.55 0.759809L1.65577 4.74019C1.37731 4.90096 1.20577 5.19808 1.20577 5.51962V13.4804C1.20577 13.8019 1.37731 14.099 1.65577 14.2598L8.55 18.2402Z"
            fill="url(#paint0_linear_2922_3136)"
        />
        <path
            d="M8.55002 17.4902C8.82848 17.651 9.17156 17.651 9.45002 17.4902L15.6947 13.8848C15.9732 13.724 16.1448 13.4269 16.1448 13.1054V5.89462C16.1448 5.57308 15.9732 5.27596 15.6947 5.11519L9.45002 1.50981C9.17156 1.34904 8.82848 1.34904 8.55002 1.50981L2.30529 5.11519C2.02683 5.27596 1.85529 5.57308 1.85529 5.89462L1.85529 13.1054C1.85529 13.4269 2.02683 13.724 2.30529 13.8848L8.55002 17.4902Z"
            fill="url(#paint1_linear_2922_3136)"
        />
        <path
            d="M8.58337 2.24056C8.84121 2.0917 9.15888 2.0917 9.41671 2.24056L15.0786 5.50944C15.3364 5.6583 15.4953 5.93341 15.4953 6.23113V12.7689C15.4953 13.0666 15.3364 13.3417 15.0786 13.4906L9.41671 16.7594C9.15888 16.9083 8.84121 16.9083 8.58337 16.7594L2.92149 13.4906C2.66365 13.3417 2.50482 13.0666 2.50482 12.7689V6.23113C2.50482 5.93341 2.66365 5.6583 2.92149 5.50944L8.58337 2.24056Z"
            fill="url(#paint2_linear_2922_3136)"
        />
        <path
            d="M9.54288 4.65851L9.46677 4.45282H9.24746H8.75331H8.534L8.45789 4.65851L7.29674 7.79647L4.17682 8.95095L3.97113 9.02706V9.24637V9.75387V9.97318L4.17682 10.0493L7.29674 11.2038L8.45789 14.3417L8.534 14.5474H8.75331H9.24746H9.46677L9.54288 14.3417L10.704 11.2038L13.824 10.0493L14.0296 9.97318V9.75387V9.24637V9.02706L13.824 8.95095L10.704 7.79647L9.54288 4.65851Z"
            fill="#050607"
            stroke="url(#paint3_linear_2922_3136)"
            stroke-width="0.63"
        />
        <defs>
            <linearGradient
                id="paint0_linear_2922_3136"
                x1="4.95"
                y1="16.25"
                x2="13.5"
                y2="2.3"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#C47C34" />
                <stop offset="0.249999" stop-color="#D48D46" />
                <stop offset="0.484374" stop-color="#D88F46" />
                <stop offset="0.723958" stop-color="#DC9F62" />
                <stop offset="1" stop-color="#CF853B" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_2922_3136"
                x1="12.4375"
                y1="15.3437"
                x2="4.87504"
                y2="3.31248"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#F2A960" />
                <stop offset="0.274553" stop-color="#FFE1C4" />
                <stop offset="0.779762" stop-color="#FFE7CF" />
                <stop offset="1" stop-color="#FCB975" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_2922_3136"
                x1="5.62502"
                y1="3.875"
                x2="12.75"
                y2="15.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#F0AA64" />
                <stop offset="0.195216" stop-color="#FFE5CB" />
                <stop offset="0.484374" stop-color="#FFB264" />
                <stop offset="0.830204" stop-color="#FFDEBC" />
                <stop offset="1" stop-color="#FFA040" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_2922_3136"
                x1="6.13663"
                y1="6.22741"
                x2="11.0457"
                y2="12.3638"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FFB265" />
                <stop offset="0.50372" stop-color="#FFD4A9" />
                <stop offset="1" stop-color="#FFA952" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
